<!--
  lovi
  用户协议 2020-1-7
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('logReg.userServiceAgreement')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <scroll>
        <pre class="text-content" v-html="serviceRule"></pre>
      </scroll>
    </div>
  </div>
</template>

<script>
export default {
  name: "agreement",
  components: {},
  data() {
    return {
      serviceRule: ""
    };
  },
  created() {
    this._getServiceRule();
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:agreementFlag", false);
    },
    _getServiceRule() {
      let vm = this;
      vm.$post("/app/index/serviceRule", {}, { loading: true }).then(res => {
        console.log("serviceRule", res);
        vm.serviceRule = res;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.text-content {
  padding: 10px;
  font-size: 14px;
  line-height: 24px;
  text-align: justify;
}
</style>
